import * as React from 'react';

class LicenseManagerDashboard extends React.Component<any, any> {
    public render() {
        return (
            <>
                <h4>License Manager</h4>
            </>
        );
    }
}

export default LicenseManagerDashboard;
